export const workshopFilterData = [
  {
    type: "workshop_product",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
  {
    type: "workshop_theme",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
  {
    type: "workshop_location",
    displayField: {
      hk: "title_hk",
      hk_en: "title_hk_en",
    },
    valueField: "location_id",
  },
];

export const genericFilterData = [
  {
    type: "member_privilege",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
  {
    type: "popular",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
  {
    type: "latest",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
];

export const staticFilterList = [
  {
    type: "member_privilege",
    label: {
      hk: "會員限定",
      hk_en: "Member Privilege",
    },
    isBoolean: true,
  },
];

export const genericLatestPopularFilterData = [
  {
    icon: "sort",
    value: 0,
    desc_hk_en: "Most Latest",
    desc_hk: "最新",
  },
  { icon: "sort", value: 1, desc_hk_en: "Most Popular", desc_hk: "最受歡迎" },
];

export const videoFilterData = [
  {
    type: "video_product",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
  {
    type: "video_theme",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
];

export const blogFilterData = [
  {
    type: "blog_product",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
  {
    type: "blog_theme",
    displayField: {
      hk: "desc_hk",
      hk_en: "desc_hk_en",
    },
    valueField: "value",
  },
];
